import { useCallback } from 'react';
import { useBeforeUnload, useBlocker, type BlockerFunction } from 'react-router-dom';

import { APP_ROUTES } from '../navigation/appRoutes';

const GANTT_PATH = APP_ROUTES.schedule.tasks;

function normalizePath(path: string): string {
  return path.replace(/\/+$/, '') || '/';
}

/**
 * Blocks in-app navigation away from the Gantt route when the schedule is dirty,
 * and warns on tab close / refresh when dirty.
 * Pair with {@link GanttLeaveConfirmModal} for the confirmation UI.
 */
export function useGanttLeaveGuard(isDirty: () => boolean) {
  const shouldBlockLeavingGantt = useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) => {
      if (normalizePath(currentLocation.pathname) !== GANTT_PATH) return false;
      if (normalizePath(nextLocation.pathname) === GANTT_PATH) return false;
      return isDirty();
    },
    [isDirty],
  );

  const blocker = useBlocker(shouldBlockLeavingGantt);

  useBeforeUnload(
    useCallback(
      (event: BeforeUnloadEvent) => {
        if (!isDirty()) return;
        event.preventDefault();
      },
      [isDirty],
    ),
  );

  return blocker;
}
